import { createTheme } from '@mui/material/styles';
import { componentOverrides } from './componentOverrides';

const typography = {
  fontFamily: '"Roboto", sans-serif',
  h1_fontFamily:'"Roboto", sans-serif',
  label_fontFamily:'"Roboto", sans-serif',
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6b5bc8',
      light: '#8879e1',
      dark: '#5b4dad',
      soft: '#efe4ff',
     
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f2f4ff',
      paper: '#ffffff',
      soft: '#f9f4ff',
    },
    text: {
      primary: '#646464',
      secondary: '#757575',
    },
    sidebar: {
      background: '#ffffff',
      text: '#212121',
      textSecondary: '#757575',
      divider: '#e0e0e0',
      hover: '#f5f5f5',
      active: '#e3f2fd',
      menuItem: {
        background: 'transparent',
        text: '#757575',
        textActive: '#212121',
        icon: '#757575',
        iconActive: '#6b5bc8',
        iconActiveBackground: '#ebe7f7',
        backgroundActive: '',
        backgroundHover: '#f5f5f5',
      },
    },
    table: {
      headerBackground: '#f9f4ff',
      oddrowBackground: '#fafafa',
      borderColor: '#e0e0e0',
    },
    textInput:{
      borderColor:'#9482d7',
      borderShadowColor:'#ebe7f7'
    },
    topbar: {
      background: '#ffffff',
      text: '#757575',
      textSecondary: '#e3f2fd',
      divider: '#1565c0',
      hover: '#1565c0',
    },
    footer: {
      background: '#ffffff',
      text: '#212121',
    },
  },
  typography,
  components: componentOverrides,
});
 export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#6b5bc8',
      light: '#8f7cdb',
      dark: '#5b4dad',
      soft: '#17161a',
    
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
      soft: '#000000a9',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
    sidebar: {
      background: '#1e1e1e',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
      active: '#6b5bc8',
      menuItem: {
        background: 'transparent',
        text: '#cecdcd',
        textActive: '#ffffff',
        icon: '#757575',
        iconActive: '#6b5bc8',
        iconActiveBackground: '#ebe7f7',
        backgroundActive: '',
        backgroundHover: '#474747',
      },
      
    },
     table: {
      headerBackground: '#141414',
      oddrowBackground: '#3a3939',
      borderColor: '#e0e0e0',
    },
    textInput:{
      borderColor:'#9482d7',
      borderShadowColor:'#ebe7f7'
    },
    topbar: {
      background: '#0a0a0a',
      text: '#ffffff',
      textSecondary: '#b3b3b3',
      divider: '#424242',
      hover: '#2d2d2d',
    },
    footer: {
      background: '#1e1e1e',
      text: '#ffffff',
    },
  },
  typography,
  components: componentOverrides,
}); 

